import React, { useState } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Details = (props) => {

  const { userdata } = props;
  const { register, formState: { errors }, handleSubmit } = useForm();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const onSubmit = (data) => {
    setLoading(true)
    const request = {};
    request.mentee_id = userdata.mentee_id;
    request.mentor_id = userdata.mentor_id;
    request.review = data.review;
    request.user_role = "Mentor";
    agent
      .post(API.LOAD_CUSTOMER + "/updateReview", request)
      .then((res) => {
        setPopupMessage(res.data.message);
        setShowPopup(true);
      })
      .catch((err) => {
        setPopupMessage("Something went wrong.Please try again.");
        setShowPopup(true);
        setLoading(false)
      });
  };

  const handleReviewPopupClose = () => {
    setShowPopup(false);
    setLoading(false);
    props.onHide(); // close modal
    history("/mentees-logs"); // navigate AFTER user clicks OK
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <label className="form-label" htmlFor="write">Write a review*</label>
                <Form.Control
                  as="textarea"
                  className={
                    errors.review ? "form-control is-invalid" : "form-control"
                  }
                  name="review"
                  defaultValue={userdata?.mentor_review}
                  aria-invalid={errors.review ? "true" : "false"}
                  {...register("review", {
                    maxLength: 600,
                    required: true
                  })}
                />
                {errors?.review && errors?.review?.type === "required" && (
                  <label className="customeValidationText text-left" htmlFor="write">
                    Please enter review
                  </label>
                )}
                {errors?.review && errors?.review?.type === "maxLength" && (
                  <label className="customeValidationText text-left" htmlFor="write">
                    Review should not more than 600 characters
                  </label>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <button
                    className="btn loginsubmit nextbtn ml-2"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <PopupModalWithOk
        show={showPopup}
        onHide={handleReviewPopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    mentee_id: PropTypes.number,
    mentor_id: PropTypes.number,
    mentor_review: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Details;
